module.exports = __webpack_public_path__ + "img/perform_4.deaccf86.svg";